import apiRequest from './wrapper';

/**
 * @method  : POST
 * @path    : /users/me/survey
 * @desc    : create survey
 */
export const createSurvey = (pathParam, params) => {
  return new Promise((resolve, reject) => {
    apiRequest('post', '/users/me/survey/', { params }, pathParam)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            // handle unauthorized error
            errorMessage = 'createSurvey:You are not authorized to perform this action';
          } else if (status === 404) {
            // handle not found error
            errorMessage = 'createSurvey: The resource you are trying to access was not found';
          } else if (status >= 500) {
            // handle server error
            errorMessage = 'createSurvey: An error occurred on the server';
          } else {
            errorMessage = data.message;
          }

          reject(new Error(errorMessage));
        } else if (error.request) {
          // The request was made but no response was received
          reject(new Error('createSurvey: No response was received from the server'));
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error);
        }
      });
  });
};

/**
 * @method  : GET
 * @path    : /users/me/ratings
 * @desc    : get ratings
 */
export const getRatings = (pathParam, params) => {
  return new Promise((resolve, reject) => {
    apiRequest('get', '/users/me/ratings', { params }, pathParam)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            // handle unauthorized error
            errorMessage = 'getRatings: You are not authorized to perform this action';
          } else if (status === 404) {
            // handle not found error
            errorMessage = 'getRatings: The resource you are trying to access was not found';
          } else if (status >= 500) {
            // handle server error
            errorMessage = 'getRatings: An error occurred on the server';
          } else {
            errorMessage = data.message;
          }

          reject(new Error(errorMessage));
        } else if (error.request) {
          // The request was made but no response was received
          reject(new Error('getRatings: No response was received from the server'));
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error);
        }
      });
  });
};
